import { getSubjectDetailApi } from "@/api/services/admin/learning-content";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching subject detail by subject ID
 */
export const useSubjectDetail = (subjectId: string | undefined) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_SUBJECT_DETAIL, subjectId],
    queryFn: () => getSubjectDetailApi(subjectId!),
    enabled: !!subjectId,
  });

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
  };
};
